<mat-card class="p-0" (click)="open('ftth')">
	<div class="card-body cursor-pointer mb-3">
		<div class="d-flex justify-content-between align-items-center">
			<div>
				<img src="{{ pathImgsMarkers }}/ftth.png?v={{ assets_version }}" alt="FTTH" class="img-ftth mr-2" />
				<span>{{ "SERVICES_MENU.PON_ETHERNET" | translate }}</span>
			</div>
		</div>
	</div>
</mat-card>

<div id="ftth" class="modal fade">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h4 class="modal-title">{{ "SERVICES_MENU.PON_ETHERNET" | translate }}</h4>
				<button type="button" class="close" aria-label="Close" data-dismiss="modal">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body">
				<app-catalog-ftth [isFromModal]="true" [buildingType]="buildingType"></app-catalog-ftth>
			</div>
		</div>
	</div>
</div>
